<template>
  <div class="base-search">
    <input
      id="search-clients"
      ref="search"
      v-model="searchstring"
      type="text"
      autocomplete="off"
      class="base-search__input"
      :class="{
        'base-search__input--left': iconPosition === 'left',
        'base-search__input--right': iconPosition === 'right',
      }"
      :placeholder="$t(placeholder)"
      @focus="close_icon = true"
      @blur="closeInput"
    >
    <base-icon
      v-if="showIcon && iconPosition === 'left'"
      :icon="icon"
      class="base-search__icon base-search__icon--left"
    />
    <base-icon
      v-if="showIcon && iconPosition === 'right'"
      :icon="icon"
      class="base-search__icon base-search__icon--right"
    />
    <base-icon
      v-if="close_icon"
      icon="x-circle-grey"
      class="base-search__icon base-search__icon--right"
      @click="cancelSearch"
    />
  </div>
</template>
<script>
export default {
  name: 'BaseSearch',
  inheritAttrs: false,
  props: {
    showIcon: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: 'common.search',
    },
    value: {
      type: String,
      required: true,
    },
    iconPosition: {
      type: String,
      default: 'right',
    },
    icon: {
      type: String,
      default: 'search-base',
    },
    // Determines whether cancelSearch event is emitted on close
    hasCancelSearch: {
      type: Boolean,
      default: false,
    },
    // Determines whether the input is focused on mount
    focusOnMount: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      close_icon: false,
      searchstring: this.value,
    };
  },
  watch: {
    value(newval) {
      this.searchstring = newval;
    },
    searchstring(newval) {
      this.$emit('input', newval);
    },
  },
  mounted() {
    // Focus on mount if prop is set
    if (this.focusOnMount) {
      this.focus();
    }
  },
  methods: {
    closeInput() {
      // eslint-disable-next-line no-return-assign
      setTimeout(() => this.close_icon = false, 200);
    },
    focus() {
      this.$refs.search.focus();
    },
    cancelSearch() {
      this.close_icon = false;
      this.searchstring = '';
      this.value = '';
      // Fulfill an action on the parent component on close if one exists
      if (this.hasCancelSearch) this.$emit('cancelSearch');
    },
  },
};
</script>
<style lang="scss" scoped>
.base-search {
  display: flex;
  align-items: center;
  margin-right: 0;
  margin-left: auto;
  position: relative;
  height: toRem(35px);
  min-width: 310px;
  height: 36px;

  &__input {
    font-family: $font-family-sans-serif-light;
    font-size: 0.75rem;
    background-color: #FFF;
    color: $black;
    border: 1px solid #C6C6C6;
    padding: 8.5px 12px;
    border-radius: 5px;
    min-width: 100%;
    height:36px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    transition: outline 0.2s;
    outline: solid 5px transparent;

    &:focus{
      // outline: solid 2px $header-bg-clients; // IDK why this color but it was designed like this.
      outline: solid 0px #0A0A0A;
      border: 1px solid #0A0A0A;
      border-radius: 5px;
    }

    &--left{
      padding-left: 36px;
    }
    &--right{
      padding-right: 2.5rem;
    }
  }

  &__icon{
    position: absolute;
    margin-right: 0;
    // top: 0;
    // bottom: 0;
    // right: 0;
    // margin: auto;
    // width: toRem(20px);
    // height: toRem(20px);
    // fill: $gray-light;
  }

  &__icon--right {
    // margin-left: -1.85rem;
    right: 10px;
  }
  &__icon--left {
    margin-right: 5px;
    left: 10px;
  }
}
</style>
